// @ts-nocheck
import { memo, useEffect } from 'react'
import { SearchIcon } from '../icons'
import { myStyles } from './modes'
import './styles.css'

export const restrictionDefault: google.maps.MapRestriction = {
  latLngBounds: {
    west: -179.999999999,
    east: 179.999999999,
    north: 85,
    south: -85,
  },
  strictBounds: true,
}

interface GoogleMapProps {
  currentPosition?: boolean
  mapOutput?: (map: google.maps.Map) => void
  onSearchChange?: (data: any) => void
  isSearch?: boolean
  isControlType?: boolean
  mapType?: google.maps.MapTypeId
  onChangeType?: (type: google.maps.MapTypeId) => void
}

const GoogleMap2 = memo((props: GoogleMapProps) => {
  const {
    mapOutput,
    isSearch,
    onSearchChange,
    isControlType,
    onChangeType,
    mapType,
    currentPosition = true,
  } = props

  useEffect(() => {
    initGoogleMap()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function createNormalControl(map: any) {
    const controlButton = document.createElement('button')
    // Set CSS for the control.
    const isActive =
      google.maps.MapTypeId.ROADMAP ===
      (mapType || google.maps.MapTypeId.ROADMAP)

    controlButton.style.backgroundColor = isActive ? '#004744' : 'transparent'
    controlButton.style.borderRadius = '6px'
    controlButton.style.border = 'none'
    controlButton.style.color = isActive ? '#FFFFFF' : '#5C5C5C'
    controlButton.style.cursor = 'pointer'
    controlButton.style.fontSize = '11.1885px'
    controlButton.style.marginLeft = '4px'
    controlButton.style.fontWeight = '600px'
    controlButton.style.lineHeight = '14px'
    controlButton.style.padding = '6px 28px'
    controlButton.style.textAlign = 'center'
    controlButton.textContent = 'Normal'
    controlButton.type = 'buttonNormal'

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener('click', () => {
      map.setMapTypeId(google.maps.MapTypeId.ROADMAP)
      const buttonButtonSatellite: any = document.querySelector(
        'button[type=buttonSatellite]',
      )
      if (buttonButtonSatellite) {
        buttonButtonSatellite.style.backgroundColor = 'transparent'
        buttonButtonSatellite.style.color = '#5C5C5C'
        controlButton.style.backgroundColor = '#004744'
        controlButton.style.color = '#FFFFFF'
      }
      if (onChangeType) onChangeType(google.maps.MapTypeId.ROADMAP)
    })

    return controlButton
  }

  function createSatelliteControl(map: any) {
    const controlButton = document.createElement('button')
    const isActive =
      google.maps.MapTypeId.HYBRID ===
      (mapType || google.maps.MapTypeId.ROADMAP)
    // Set CSS for the control.
    controlButton.style.backgroundColor = isActive ? '#004744' : 'transparent'
    controlButton.style.borderRadius = '6px'
    controlButton.style.border = 'none'
    controlButton.style.color = isActive ? '#FFFFFF' : '#5C5C5C'
    controlButton.style.cursor = 'pointer'
    controlButton.style.zIndex = '1'
    controlButton.style.fontSize = '11.1885px'
    controlButton.style.fontWeight = '600px'
    controlButton.style.marginLeft = '6px'
    controlButton.style.lineHeight = '14px'
    controlButton.style.padding = '6px 28px'
    controlButton.style.textAlign = 'center'
    controlButton.textContent = 'Satellite'
    controlButton.type = 'buttonSatellite'

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener('click', () => {
      map.setMapTypeId(google.maps.MapTypeId.HYBRID)
      const buttonButtonNormal: any = document.querySelector(
        'button[type=buttonNormal]',
      )
      if (buttonButtonNormal) {
        buttonButtonNormal.style.backgroundColor = 'transparent'
        buttonButtonNormal.style.color = '#5C5C5C'

        controlButton.style.backgroundColor = '#004744'
        controlButton.style.color = '#FFFFFF'
      }
      if (onChangeType) onChangeType(google.maps.MapTypeId.HYBRID)
    })

    return controlButton
  }

  function createGroupButton(map: any) {
    const controlButton = document.createElement('div')

    // Set CSS for the control.
    controlButton.style.backgroundColor = '#FFFFFF'
    controlButton.style.boxShadow = '0px 0px 30px rgba(132, 132, 132, 0.25)'
    controlButton.style.borderRadius = '6px'
    controlButton.style.padding = '4px'
    controlButton.style.height = '35px'
    controlButton.style.width = '207.4px'
    controlButton.style.marginBottom = '15px'
    controlButton.style.marginLeft = '200px'

    return controlButton
  }

  function createGroupSearch(map: any) {
    const controlButton = document.createElement('div')

    // Set CSS for the control.
    controlButton.style.backgroundColor = 'transparent'

    return controlButton
  }

  function SearchIconMap(map: any) {
    const controlButton = document.getElementById(
      'search-icon',
    ) as HTMLInputElement

    // Set CSS for the control.
    controlButton.style.marginLeft = '527px'
    controlButton.style.marginTop = '24px'
    controlButton.style.position = 'absolute'

    return controlButton
  }

  const initGoogleMap = () => {
    const refMap = document.getElementById('GoogleMap2')
    if (!window.google) {
      setTimeout(() => {
        initGoogleMap()
      }, 1000)
      return
    }
    if (!refMap) return

    const mapProperties: google.maps.MapOptions = {
      center: new google.maps.LatLng(1.2271, 103.8431),
      zoom: 18,
      mapTypeId: mapType || google.maps.MapTypeId.HYBRID,
      disableDefaultUI: true,
      tilt: 0,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
      },
      restriction: {
        latLngBounds: {
          west: -179.999999999,
          east: 179.999999999,
          north: 85,
          south: -85,
        },
        strictBounds: true,
      },
      backgroundColor: 'hsla(0, 0%, 0%, 0)',
      styles: myStyles,
    }

    const map = new google.maps.Map(refMap, mapProperties)

    if (isControlType) {
      createControlType(map)
    }

    if (isSearch) {
      const searchIconControl = SearchIconMap(map)
      const groupSearchControl = createGroupSearch(map)
      const input = document.getElementById('pac-input') as HTMLInputElement
      groupSearchControl.appendChild(input)
      groupSearchControl.appendChild(searchIconControl)

      map.controls[google.maps.ControlPosition.TOP_LEFT].push(
        groupSearchControl,
      )
      const searchBox = new google.maps.places.SearchBox(input)

      searchBox.addListener('places_changed', () => {
        const places = searchBox.getPlaces()
        if (!places || !places[0]) {
          return
        }
        if (onSearchChange) onSearchChange(places[0])
      })
    }

    if (navigator.geolocation && currentPosition) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude,
        )
        map.setCenter(pos)
      })
    }
    if (mapOutput) mapOutput(map)
  }

  const createControlType = (map: google.maps.Map) => {
    const groupButtonControl = createGroupButton(map)
    const normalControl = createNormalControl(map)
    const satelliteControl = createSatelliteControl(map)

    groupButtonControl.appendChild(normalControl)
    groupButtonControl.appendChild(satelliteControl)
    map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(
      groupButtonControl,
    )
  }

  return (
    <>
      <div
        id="GoogleMap2"
        style={{ width: '100%', height: '100%', flexGrow: 1 }}
      />
      {isSearch && (
        <div>
          <div id="search-icon">
            <SearchIcon />
          </div>

          <input
            id="pac-input"
            className="inputSearch icon"
            type="text"
            placeholder="Search Place"
          />
        </div>
      )}
    </>
  )
})

export default GoogleMap2
